import {
  SendReminderData,
  SendReminderDataProps,
} from '../../../../../types/Invoicing/Invoices/InvoiceSendReminder/invoicesSendRemindertype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  invoiceSendReminderListApiConfig,
} from '../../../apiList'

const getSendReminderDetails = async (): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceSendReminderListApiConfig.getReminderDescription,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getSendReminderLogs = async (
  invoiceId?: number,
): Promise<SendReminderData[]> => {
  const url =
    typeof invoiceId === 'number'
      ? `${invoiceSendReminderListApiConfig.getReminderLogs}?invoiceId=${invoiceId}`
      : invoiceSendReminderListApiConfig.getReminderLogs

  const requestConfig = getAuthenticatedRequestConfig({
    url,
    method: AllowedHttpMethods.get,
    params: typeof invoiceId === 'number' ? { invoiceId } : undefined,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getInvoiceReminderlog = async (
  senddata: SendReminderDataProps,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceSendReminderListApiConfig.invoiceReminderlog,
    method: AllowedHttpMethods.post,
    data: {
      bcc: senddata.bcc,
      cc: senddata.cc,
      description: senddata.description,
      details: senddata.details,
      invoiceId: senddata.invoiceId,
      subject: senddata.subject,
      to: senddata.to,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const invoicesSendReminderListApi = {
  getSendReminderDetails,
  getSendReminderLogs,
  getInvoiceReminderlog,
}

export default invoicesSendReminderListApi
